import { Container, FormGroup } from "reactstrap";
import { Formik, Field, Form, ErrorMessage, useFormikContext } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { DatePickerInput } from "../../share/DatePickerInput";
import { NumericFormat } from 'react-number-format';
import { CustomInputNumeric } from "../../share/CustomInputNumeric";
import CreateTableComponent from "../../share/CreateTableComponent";
import { IoMdCreate } from "react-icons/io";
import Modal from "react-modal"
import { getCustomStyles } from "../../share/ModalStyle";
import { CgClose } from "react-icons/cg";
import { Loading } from "../../share/loading";
import { NumberWithCommas } from "../../share/NumberWithCommas";
import { ConvertDateToThaiBuddhist } from "../../share/ConvertDateToThaiBuddhist";

import { CiCalendarDate } from "react-icons/ci";
import TextErrors from "../../share/TextErrors";
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';

export function ReceivingDebtComponent() {
    const navigate = useNavigate();
    const myCustomStyles = getCustomStyles()
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [historyReceivingDept, setHistoryReceivingDept] = useState([]);
    const [getInstallment, setGetInstallment] = useState(null);
    // console.log("getInstallment", getInstallment);
    const [openModalForm, setOpenModalForm] = useState(false)
    const ToggleModalForm = () => setOpenModalForm(!openModalForm)
    const user = JSON.parse(localStorage.getItem("userData"));
    let borrowId = searchParams.get("req")

    function AutoSumPayment() {
        const { values, setFieldValue } = useFormikContext();

        useEffect(() => {
            const p = Number(String(values.principalAmt || 0).replace(/,/g, "")) || 0;
            const i = Number(String(values.interestAmt || 0).replace(/,/g, "")) || 0;
            const pe = Number(String(values.penaltyAmount || 0).replace(/,/g, "")) || 0;
            const sum = (p + i + pe).toFixed(2);

            if (String(values.paymentamt ?? "") !== sum) {
                setFieldValue("paymentamt", sum, false); // false = ไม่ validate ทันที
            }
        }, [values.principalAmt, values.interestAmt, values.penaltyAmount, values.paymentamt, setFieldValue]);

        return null; // component นี้ไม่ render อะไร
    }

    async function getHistoryReceivingDept() {
        setLoading(true)
        let postData = new FormData();
        postData.append("borrowId", borrowId)
        try {
            let res = await fetch("/api/ContactBorrow/getHistoryReceivingDept", {
                method: "POST",
                body: postData
            })
            let resJson = await res.json();
            if (resJson.status === 1) {
                setHistoryReceivingDept(resJson.dataenum)
                // setHistorySelect(resJson.dataenum.map(item => item.installment))
            }


        } catch (e) {
            // console.log(e)
        } finally {
            setLoading(false)
        }

    }
    useEffect(() => {

        getHistoryReceivingDept()
    }, []);
    const toNum = (v) => Number(String(v ?? 0).replace(/,/g, '') || 0);

    const formInitialValues = {
        borrowId: borrowId,
        paydate: "",
        // รวมตั้งต้น = เงินต้น + ดอกเบี้ย + เบี้ยปรับ
        paymentamt: (
            toNum(getInstallment?.principalAmt) +
            toNum(getInstallment?.interestAmt) +
            toNum(getInstallment?.penaltyAmount)
        ).toFixed(2),

        principalAmt: getInstallment?.principalAmt ?? "",
        interestAmt: getInstallment?.interestAmt ?? "0",
        penaltyAmount: getInstallment?.penaltyAmount ?? "0",
        installmentPaymentId: getInstallment?.installMentPayMentId,
        Updateby: user.deptId,
        Createby: user.deptId,
    };


    const validateSchema = Yup.object().shape({
        paydate: Yup.string().required("กรุณาเลือกวันที่โอนเงิน"),
        paymentamt: Yup.string().required("กรุณาระบุจำนวนเงินที่โอน"),
        // installment: Yup.string().notOneOf(hisTorySelect, "งวดชำระนี้ ได้รับการชำระเงินไปแล้ว").required("กรุณาระบุงวดที่จ่าย"),

    });

    const onSubmit = async (values) => {
        Swal.fire({
            icon: "info",
            title: "ยืนยันการบันทึกข้อมูลหรือไม่ ?",
            text: "หากยืนยันการบันทึกแล้ว จะไม่สามารถแก้ไขข้อมูลได้",
            confirmButtonColor: "#0A66C2",
            confirmButtonText: "ตกลง",
            cancelButtonText: 'ยกเลิก',
            cancelButtonColor: '#d33',
            showCancelButton: true,
        }).then(async (result) => {
            if (result.isConfirmed) {
                let postData = new FormData();
                Object.entries(values).forEach(([key, value]) => {
                    postData.append(key, value);
                });
                try {
                    let res = await fetch("/api/ContactBorrow/saveInstallment", {
                        method: "POST",
                        body: postData,
                    });

                    let resJson = await res.json();
                    // console.log(resJson.dataenum);

                    if (resJson.status === 1) {
                        Swal.fire({
                            icon: "success",
                            title: "บันทึกข้อมูลสำเร็จ",
                            text: "",
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                window.location.reload()
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "บันทึกข้อมูลไม่สำเร็จ",
                            text: `เนื่องจาก ${resJson.message}`,
                            confirmButtonColor: "#0A66C2",
                            confirmButtonText: "ตกลง",
                        });
                    }
                } catch (e) {
                    // console.log("err =>", e)
                }
            }
        })


    };

    // คอมโพเนนต์แก้ไข Due Date
    const EditDueDate = ({ installmentId, currentDueDate, onUpdated }) => {
        const [open, setOpen] = useState(false);
        const toggle = () => setOpen(!open);
        const myCustomStyles = getCustomStyles();

        // แปลงค่า default ของ currentDueDate ถ้ามาเป็นสตริง (เช่น "2025-09-10")
        // DatePickerInput ของคุณรองรับ prop แบบ Field component อยู่แล้ว
        const initialValues = {
            newDueDate: "",
            installmentId: installmentId,
        };

        const validateSchema = Yup.object().shape({
            newDueDate: Yup.string().required("กรุณาเลือกวันที่ครบกำหนดใหม่"),
        });

        const onSubmit = async (values, { setSubmitting }) => {
            // console.log("values", values);
            try {
                const confirmed = await Swal.fire({
                    icon: "question",
                    title: "ยืนยันการแก้ไขวันครบกำหนด?",
                    text: `จากเดิม ${currentDueDate || "-"} เป็นวันที่ ${ConvertDateToThaiBuddhist(values.newDueDate)}`,
                    showCancelButton: true,
                    confirmButtonText: "ยืนยัน",
                    cancelButtonText: "ยกเลิก",
                    confirmButtonColor: "#0A66C2",
                    cancelButtonColor: "#d33",
                });

                if (!confirmed.isConfirmed) return;

                const fd = new FormData();
                // ⚠️ ปรับชื่อฟิลด์/เอ็นด์พอยต์ให้ตรงกับแบ็กเอนด์จริงของคุณ
                fd.append("installMentPayMentId", values.installmentId);
                fd.append("newDueDate", values.newDueDate);

                const res = await fetch("/api/ContactBorrow/updateInstallmentDueDate", {
                    method: "POST",
                    body: fd,
                });
                const json = await res.json();

                if (json.status === 1) {
                    await Swal.fire({
                        icon: "success",
                        title: "แก้ไขวันครบกำหนดสำเร็จ",
                        confirmButtonText: "ตกลง",
                        confirmButtonColor: "#0A66C2",
                    });
                    toggle();
                    // รีเฟรชตารางด้านนอก
                    onUpdated?.();
                } else {
                    Swal.fire({
                        icon: "error",
                        title: "ไม่สามารถแก้ไขได้",
                        text: `เนื่องจาก ${json.message || "เกิดข้อผิดพลาด"}`,
                        confirmButtonText: "ตกลง",
                        confirmButtonColor: "#0A66C2",
                    });
                }
            } catch (err) {
                // console.log(err);
                Swal.fire({
                    icon: "error",
                    title: "ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้",
                    confirmButtonText: "ตกลง",
                    confirmButtonColor: "#0A66C2",
                });
            } finally {
                setSubmitting(false);
            }
        };

        return (
            <div>
                {/* ไอคอนสำหรับเปิดโมดัล */}
                <CiCalendarDate className="mx-1 style-icon" onClick={toggle} />

                {/* โมดัลแก้ไข Due Date */}
                <Modal
                    isOpen={open}
                    onRequestClose={toggle}
                    style={{
                        ...myCustomStyles,
                        content: { ...myCustomStyles.content, overflow: 'visible' }
                    }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h3 style={{ color: "#0E527E", maxWidth: "720px", width: "100%", height: "100%" }}>
                            แก้ไขวันที่ครบกำหนดชำระ (งวด)
                        </h3>
                        <CgClose onClick={toggle} className="style-iconmodal" />
                    </div>
                    <hr />

                    <Formik
                        initialValues={initialValues}
                        validationSchema={validateSchema}
                        onSubmit={onSubmit}
                    >
                        {() => (
                            <Form autoComplete="off" className="px-5">
                                <div className="px-5 my-4">
                                    <FormGroup>
                                        <span className="type-register mb-2">
                                            วันที่ครบกำหนดเดิม :
                                        </span>
                                        {currentDueDate || "-"}
                                    </FormGroup>

                                    <FormGroup>
                                        <span className="type-register mb-2">
                                            วันที่ครบกำหนด (ใหม่)
                                            <ErrorMessage name="newDueDate" component={TextErrors} />
                                        </span>
                                        {/* ใช้ DatePickerInput ตัวเดียวกับฟอร์มหลัก */}
                                        <Field
                                            name="newDueDate"
                                            component={(props) => <DatePickerInput {...props} />}
                                        />
                                    </FormGroup>

                                    <FormGroup className="my-4">
                                        <div className="d-flex justify-content-evenly align-items-center">
                                            <button className="btn-green rounded-pill w-25 mb-2" type="submit">
                                                บันทึก
                                            </button>

                                            <button
                                                className="btn-red rounded-pill w-25 mb-2"
                                                type="button"
                                                onClick={toggle}
                                            >
                                                ยกเลิก
                                            </button>
                                        </div>
                                    </FormGroup>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </Modal>
            </div>
        );
    };


    const COLUMNS = [
        {
            Header: "งวดที่",
            accessor: "installment",
        },
        {
            Header: "วันที่ครบกำหนดชำระ",
            accessor: "dueDate",
        },
        {
            Header: "วันที่ครบกำหนดชำระ (ใหม่)",
            accessor: "newDueDate",
            Cell: ({ value }) => {
                return (
                    <>{value ?? "-"}</>
                )
            }
        },
        {
            Header: "เงินต้น",
            accessor: "principalAmt",
            Cell: ({ value }) => {
                return (
                    <>{NumberWithCommas(Number(value))} บาท</>
                )
            }
        },
        {
            Header: "ดอกเบี้ย",
            accessor: "interestAmt",
            Cell: ({ value }) => {
                return (
                    <>{NumberWithCommas(Number(value))} บาท</>
                )
            }
        },
        {
            Header: "เบี้ยปรับ",
            accessor: "penaltyAmount",
            Cell: ({ value }) => {
                return (
                    <>{value !== null ? value : "-"}</>
                )


            }
        },
        {
            Header: "จำนวนเงินที่ต้องได้รับชำระ",
            accessor: "installMentPaymentAmt",
            Cell: ({ value }) => {
                return (
                    <>{value !== null ? NumberWithCommas(Number(value)) : "-"}</>
                )
            }
        },
        {
            Header: "วันที่รับชำระเงิน",
            accessor: "payDateStr",
            Cell: ({ value }) => {
                return (
                    <>{value !== null ? value : "-"}</>
                )


            }
        },

        {
            Header: "จำนวนเงินที่ได้รับชำระ",
            accessor: "paymentamt",
            Cell: ({ value }) => {
                return (
                    <>{value !== null ? NumberWithCommas(Number(value)) : "-"}</>
                )


            }
        },
        {
            Header: "บันทึกรับชำระเงิน",
            accessor: "installMentPayMentId",
            Cell: ({ row, value }) => {
                // console.log("value",value)
                // console.log("row",row)
                return (
                    <>
                        <button
                            className="btn-blue create-button-form"
                            // disabled={row.original.paymentamt !== null ? true : false}
                            onClick={() => {
                                setGetInstallment(row.original)
                                ToggleModalForm()
                            }}
                        >
                            <IoMdCreate className="mx-2" />
                            {row.original.paymentamt == null ? "บันทึกการรับชำระเงิน" : "แก้ไขการรับชำระเงิน"}

                        </button>
                        <Tippy content="แก้ไขวันที่ครบกำหนดชำระ">
                            <span>
                                <EditDueDate
                                    installmentId={row.original.installMentPayMentId}
                                    currentDueDate={row.original.dueDate}
                                    onUpdated={getHistoryReceivingDept}
                                />
                            </span>
                        </Tippy>
                        {/* <Tippy content="แก้ไขวันที่ครบกำหนดชำระ">
                            <EditDueDate borrowId={row.original} />
                        </Tippy> */}

                    </>


                )
            }
        }

    ]

    if (loading) { return <Loading /> }
    return (
        <Container className="d-flex flex-column justify-content-center align-items-center mb-5" style={{ maxWidth: "1800px" }}>
            <div className="">
                <div className="">
                    <CreateTableComponent
                        column={COLUMNS}
                        dataInput={historyReceivingDept}
                        FormInput={null}
                        showEntrie={true}
                        showPage={true}
                    />
                    <div className="d-flex justify-content-center align-items-center mt-3">
                        <button type="button" className="btn-blue w-25" onClick={() => navigate("/borrowing")}>ย้อนกลับ</button>
                    </div>

                </div>

            </div>

            <Modal
                isOpen={openModalForm}
                onRequestClose={ToggleModalForm}
                style={myCustomStyles}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <h3 style={{ color: "#0E527E", maxWidth: "720px", width: "100%" }}>บันทึกการรับชำระเงิน</h3>
                    <CgClose onClick={ToggleModalForm} className="style-iconmodal" />
                </div>
                <hr />
                <Formik
                    initialValues={formInitialValues}
                    validationSchema={validateSchema}
                    onSubmit={onSubmit}
                    enableReinitialize
                >
                    {({ values, errors }) => {

                        // console.log("values", values);
                        // console.log("formik.error", errors)
                        return (

                            <Form autoComplete="off" className="px-5">
                                <AutoSumPayment />
                                <div className="px-5 my-5">
                                    <FormGroup>
                                        <span className="type-register mb-2">
                                            วันที่ชำระ
                                            <ErrorMessage name="paydate" component={TextErrors} />
                                        </span>
                                        <Field name="paydate" component={(props) => <DatePickerInput {...props} />} />
                                    </FormGroup>
                                    <FormGroup>
                                        <span className="type-register mb-2">
                                            เงินต้น
                                            <ErrorMessage name="principalAmt" component={TextErrors} />
                                        </span>
                                        <Field name="principalAmt">
                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    {...field}
                                                    allowLeadingZeros
                                                    thousandSeparator=","
                                                    decimalScale={2}
                                                    isNumericString={true}
                                                    displayType="number"
                                                    value={values.principalAmt}
                                                    format={(value) => value.toLocaleString()}
                                                    onValueChange={(values, sourceInfo) => {
                                                        let value1 = values.value.replace(/,/g, '')
                                                        //   setFieldValue(field.name, values.value.replace(/,/g, ''))
                                                        setFieldValue(field.name, value1)
                                                    }}
                                                    customInput={CustomInputNumeric}
                                                    className={meta.error && meta.touched ? "input-error" : ""}
                                                />

                                            )}
                                        </Field>
                                    </FormGroup>
                                    <FormGroup>
                                        <span className="type-register mb-2">
                                            ดอกเบี้ย
                                            <ErrorMessage name="interestAmt" component={TextErrors} />
                                        </span>
                                        <Field name="interestAmt">
                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    {...field}
                                                    allowLeadingZeros
                                                    thousandSeparator=","
                                                    decimalScale={2}
                                                    isNumericString={true}
                                                    displayType="number"
                                                    value={values.interestAmt}
                                                    format={(value) => value.toLocaleString()}
                                                    onValueChange={(values, sourceInfo) => {
                                                        let value1 = values.value.replace(/,/g, '')
                                                        //   setFieldValue(field.name, values.value.replace(/,/g, ''))
                                                        setFieldValue(field.name, value1)
                                                    }}
                                                    customInput={CustomInputNumeric}
                                                    className={meta.error && meta.touched ? "input-error" : ""}
                                                />

                                            )}
                                        </Field>
                                    </FormGroup>
                                    <FormGroup>
                                        <span className="type-register mb-2">
                                            เบี้ยปรับ
                                            <ErrorMessage name="penaltyAmount" component={TextErrors} />
                                        </span>
                                        <Field name="penaltyAmount">
                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    {...field}
                                                    allowLeadingZeros
                                                    thousandSeparator=","
                                                    decimalScale={2}
                                                    isNumericString={true}
                                                    displayType="number"
                                                    value={values.penaltyAmount}
                                                    format={(value) => value.toLocaleString()}
                                                    onValueChange={(values, sourceInfo) => {
                                                        let value1 = values.value.replace(/,/g, '')
                                                        // console.log("value1", value1);
                                                        //   setFieldValue(field.name, values.value.replace(/,/g, ''))
                                                        setFieldValue(field.name, value1)
                                                    }}
                                                    customInput={CustomInputNumeric}
                                                    className={meta.error && meta.touched ? "input-error" : ""}
                                                />

                                            )}
                                        </Field>
                                    </FormGroup>

                                    <FormGroup>
                                        <span className="type-register mb-2">
                                            รวมจำนวนเงินที่ได้รับชำระ
                                            <ErrorMessage name="paymentamt" component={TextErrors} />
                                        </span>
                                        <Field name="paymentamt">
                                            {({ field, meta, form: { setFieldValue, values } }) => (
                                                <NumericFormat
                                                    {...field}
                                                    allowLeadingZeros
                                                    thousandSeparator=","
                                                    decimalScale={2}
                                                    isNumericString={true}
                                                    displayType="number"
                                                    value={values.paymentamt}
                                                    format={(value) => value.toLocaleString()}
                                                    onValueChange={(values, sourceInfo) => {
                                                        let value1 = values.value.replace(/,/g, '')
                                                        //   setFieldValue(field.name, values.value.replace(/,/g, ''))
                                                        setFieldValue(field.name, value1)
                                                    }}
                                                    disabled
                                                    customInput={CustomInputNumeric}
                                                    className={meta.error && meta.touched ? "input-error" : ""}
                                                />

                                            )}
                                        </Field>


                                    </FormGroup>
                                    <FormGroup className="my-4">
                                        <div className="d-flex justify-content-evenly align-items-center">
                                            <button className="btn-green rounded-pill w-25 mb-2" type="submit">
                                                บันทึก
                                            </button>

                                            <button className="btn-red rounded-pill w-25 mb-2"
                                                type="button"
                                                onClick={ToggleModalForm}>
                                                ยกเลิก
                                            </button>
                                        </div>

                                    </FormGroup>
                                </div>
                            </Form>


                        );
                    }}
                </Formik>


            </Modal>



        </Container>
    );
}